__turbopack_context__.v({
  "body": "BookWithOther-module-scss-module__7LgenW__body",
  "button": "BookWithOther-module-scss-module__7LgenW__button",
  "header": "BookWithOther-module-scss-module__7LgenW__header",
  "root": "BookWithOther-module-scss-module__7LgenW__root",
});
